import React from "react";
import { object, array, string, number, bool } from "prop-types";
import LinkTag from "../link-tag";

import CardImage from "../../atoms/cardimage";
import Headline from "../../atoms/headline";

import { getHeadline } from "../../utils/utils";

import "./customStoryCard7.m.css";

const CustomStoryCard7 = ({
  useAlternateHeadline,
  story,
  aspectRatio,
  imageType,
  widths,
  headerType,
  isExternalStory,
  rel,
}) => {
  const headline = getHeadline(story);

  return (
    <div styleName="wrapper" className="custom-story-card-7">
      <LinkTag href={story.url} styleName="headline-link" isExternalStory={isExternalStory} rel={rel}>
        <Headline text={headline} headerType={headerType} story={story} useAlternateHeadline={useAlternateHeadline} />
      </LinkTag>

      <LinkTag href={story.url} styleName="image-link" isExternalStory={isExternalStory} rel={rel}>
        <CardImage story={story} aspectRatio={aspectRatio} imageType={imageType} widths={widths} eager={true} />
      </LinkTag>
    </div>
  );
};

CustomStoryCard7.defaultProps = {
  aspectRatio: [4, 3],
  imageType: "image4x3",
  headerType: 4,
  widths: [100],
  isExternalStory: false,
};

CustomStoryCard7.propTypes = {
  story: object.isRequired,
  aspectRatio: array,
  imageType: string,
  widths: array,
  headerType: number,
  useAlternateHeadline: bool,
  isExternalStory: bool,
  rel: string,
};

export default CustomStoryCard7;
